import { SiteSearch }  from "./react/site-search";
import { PurchaseFunnel }  from "./react/purchase-funnel";
import { MediaPurchaseFunnel }  from "./react/media-purchase-funnel";
import React from "react";
import CONSTS from "./react/components/pj-constants";


Rev.Window = {
    width:0,
    height:0
};
Rev.Parallax = {
    x:0,
    y:0
};
Rev.calcualateParallaxOffset = function ($,e){
    Rev.Parallax.x = (e.pageX - (Rev.Window.width / 2)) / Rev.Window.width;
    Rev.Parallax.y = (e.pageY - $(window).scrollTop() - (Rev.Window.height / 2)) / Rev.Window.height;
    // console.log(Rev.Parallax);
    // $('.masthead-size-full').css('height', $(window))
};

Rev.animateStripes = function($) {
    Rev.$animatedStripes.css('background-position',(50 -(Rev.Parallax.x*100)) + '% ' + (50 - (Rev.Parallax.y*100))+'%');
};

window.filterableServiceUpdates = function($filterable) {
    if (jQuery('.open-issues .filterable-item', $filterable).length === jQuery('.open-issues .filterable-item.filtered-out', $filterable).length) {
        jQuery('.open-issues', $filterable).addClass('no-issues');
    } else {
        jQuery('.open-issues', $filterable).removeClass('no-issues');
    }

    if (jQuery('.closed-issues .filterable-item', $filterable).length === jQuery('.closed-issues .filterable-item.filtered-out', $filterable).length) {
        jQuery('.closed-issues', $filterable).addClass('no-issues');
    } else {
        jQuery('.closed-issues', $filterable).removeClass('no-issues');
    }
};

jQuery(document).ready(function($){
    console.log('jQuery start: ', ((new Date).getTime() - Rev.stopWatch) / 1000);
    Rev.$body = $('body');


    //DF: when slide change stop the video from playing.
    var compactSwiper = new Swiper ('.rev-faq-widget .layout-compact .swiper-container', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 20,
    });

    // //DF: when slide change stop the video from playing.
    // var fullSwiper = new Swiper ('.rev-faq-widget .swiper-container.layout-full', {
    //     // Navigation arrows
    //     navigation: {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //     },
    //
    //     slidesPerView: 3,
    //     // centeredSlides: true,
    //     spaceBetween: 20,
    // });

    var carouselWidget = new Swiper ('.rev-carousel-widget .swiper-container', {
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        },
        slidesPerView: 3,
        // centeredSlides: true,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
        }
    });
    $('.rev-carousel-widget .swiper-container').each(function () { //mark swipers with pagination
        if ($('.swiper-pagination-bullet', this).length) {
            $(this).addClass('has-pagination');
        }
    });

    $(window).resize(function (e) {
        Rev.Window.width = $(window).width();
        Rev.Window.height = $(window).height();
    });
    $(window).trigger('resize');
    Rev.$body.on('mousemove', function (e) {
        Rev.calcualateParallaxOffset($,e);
    });
    Rev.$animatedStripes = $('.bundle-products-widget .parallax');

    Rev.$animatedStripes.each(function () {
        var width = $(this).width();
        var height = $(this).height();
        $(this).parallax({
            sensitivityY:0.9,
            sensitivityX:0.9,
            focusZ:110,
            width:width,
            height:height,
            internalOnly: true
        });
    });

    //DF: figure out how to reset parallax dimensions
    var parallaxResizeTimeout = null;
    $(window).resize(function (e) {
        if (parallaxResizeTimeout !== null) {
            clearTimeout(parallaxResizeTimeout);
        }
        parallaxResizeTimeout = setTimeout(function () {
            Rev.$animatedStripes.each(function () {
                var width = $(this).width();
                var height = $(this).height();

                // console.log('Reset parallax', $parallax);
                // $(this).parallax().option('width', width);
                // $(this).parallax().option('height', height);
                // $(this).parallax().reset();
                $(this).parallax({
                    sensitivityY:0.9,
                    sensitivityX:0.9,
                    focusZ:110,
                    width:width,
                    height:height,
                    internalOnly: true
                });
            });
        }, 310);
    });


    $('.masthead-parallax.parallax').each(function () {
        $(this).parallax({
            sensitivityY:0.2,
            sensitivityX:0.2,
            focusZ:110
        });
    });


    $('.channels-view-toggle').click(function () {
        var $id = $(this).data('channels');
        var $parent = $('#'+$id);
        if ($parent.hasClass('open')) { return; }

        $('.channels', $parent).append($('#channels-'+$id).html());
        $('.channels', $parent).css('max-height', 'initial');

        $parent.addClass('open');
        ScrollReveal().sync();
        $(this).remove();
    });

    $(function() {
        Tabbed.init($);
    });

    var $grid = $('.posts-container').masonry({
        itemSelector: '.post-preview',
        percentPosition: true
    });
    $grid.imagesLoaded().progress( function() {
        $grid.masonry('layout');
    });
    var masonryResizeTimeout = null;
    $(window).resize(function (e) {
        if (masonryResizeTimeout !== null) {
            clearTimeout(masonryResizeTimeout);
        }
        masonryResizeTimeout = setTimeout(function () {
            masonryResizeTimeout = null;
            $grid.masonry('layout');
        }, 310);

    });
    $('.rev-faq-widget .questions .questions-container').masonry({
        itemSelector: '.question',
        percentPosition: true
    });


    $('.navigation.pagination').css('display', 'block');

    //Parse for eventual CMS added shop links
    $('.shoplink').each(function() {
        var $shoplink = $(this);
        $('a', this).each(function () {
            var href = $(this).attr('href');
            var $a = $(this);
            if (href && href.charAt(0) === '#') {
                var ID = parseInt(href.replace('#', ''));
                if (ID) {
                    $a.attr('href', '/purchase?revaction=product&revdata=' + encodeURIComponent(JSON.stringify({id:ID})));
                    $a.attr('data-rev-purchase-id', ID);
                    $shoplink.addClass('purchase-start');
                }
            }
        })
    });

    Rev.$body.on("click", '[data-rev-purchase-id]', function(e) {
        e.preventDefault();

        var $startElement = $(this).closest('.purchase-start');
        var startOffset = $startElement.offset();
        var startWidth = $startElement.innerWidth();
        var startHeight = $startElement.innerHeight();

        //DF: attach only once
        $('body').on('purchase-funnel-loaded', function(e){
            console.log('Animation started');

            var $placeholder = null;
            if ($('.purchase-placeholder').length) {
                $placeholder = $('.purchase-placeholder');
            } else {
                $placeholder = $('<div class="purchase-placeholder" style="left: '+startOffset.left+'px; top:'+startOffset.top+'px; width: '+startWidth+'px; height: '+startHeight+'px"></div>');
                $('body')
                    .append("<div class='purchase-overlay'></div>")
                    .append($placeholder)
                    .addClass('purchase-journey-on');
                $('html').addClass('purchase-journey-on');
            }
            // $('.purchase-journey-container').css('top', startOffset.top-100+'px');

            $('.purchase-overlay').addClass('active');

            $( 'html, body' ).animate( { scrollTop: 0 } );

            Rev.$orderSummaryOffset = $('.purchase-funnel .order-summary').offset().top;
            Rev.$orderSummaryHeight = $('.purchase-funnel .order-summary').innerHeight();
            $('.purchase-journey-container').addClass('init-done');

        });

        //DF: attach only once
        $('body').on('close-purchase-journey', function(e){
            wp.element.unmountComponentAtNode(document.getElementById( 'rev-purchase-funnel' ));

            $('.purchase-journey-container').removeClass('init-done');

            $('body .purchase-overlay').remove();
            $('.purchase-placeholder').remove();
            $('body').removeClass('purchase-journey-on').removeClass('order-complete');
            $('html').removeClass('purchase-journey-on');
            $('.purchase-complete').remove();

        })
            .on('complete-purchase-journey', function(e, data){
                $('.purchase-journey-container').hide();
                $('.purchase-overlay').hide();
                $(this).addClass('order-complete');
                $( 'html, body' ).animate( { scrollTop: 0 } );
                setTimeout(function(){
                    window.location.href = "/order-complete/";
                });
            });

        wp.element.render(
            wp.element.createElement( PurchaseFunnel, {
                id:$(this).attr('data-rev-purchase-id')
            }),
            document.getElementById( 'rev-purchase-funnel' )
        );
    });
    // $('[data-rev-purchase-id]').first().trigger('click');
    //

    Rev.$body.on("click", '[data-rev-media-purchase-id]', function(e) {
        e.preventDefault();

        var $startElement = $(this).closest('.purchase-start');
        var startOffset = $startElement.offset();
        var startWidth = $startElement.innerWidth();
        var startHeight = $startElement.innerHeight();

        //DF: attach only once
        $('body').on('media-purchase-funnel-loaded', function(e){
            console.log('Animation started');

            var $placeholder = null;
            if ($('.purchase-placeholder').length) {
                $placeholder = $('.purchase-placeholder');
            } else {
                $placeholder = $('<div class="purchase-placeholder" style="left: '+startOffset.left+'px; top:'+startOffset.top+'px; width: '+startWidth+'px; height: '+startHeight+'px"></div>');
                $('body')
                    .append("<div class='purchase-overlay'></div>")
                    .append($placeholder)
                    .addClass('purchase-journey-on');
                $('html').addClass('purchase-journey-on');
            }
            // $('.purchase-journey-container').css('top', startOffset.top-100+'px');

            $('.purchase-overlay').addClass('active');

            $( 'html, body' ).animate( { scrollTop: 0 } );

            Rev.$orderSummaryOffset = $('.purchase-funnel .order-summary').offset().top;
            Rev.$orderSummaryHeight = $('.purchase-funnel .order-summary').innerHeight();
            $('.purchase-journey-container').addClass('init-done');

        })

        //DF: attach only once
        .on('close-media-purchase-journey', function(e){
            wp.element.unmountComponentAtNode(document.getElementById( 'rev-purchase-funnel' ));

            $('.purchase-journey-container').removeClass('init-done');

            $('body .purchase-overlay').remove();
            $('.purchase-placeholder').remove();
            $('body').removeClass('purchase-journey-on').removeClass('order-complete');
            $('html').removeClass('purchase-journey-on');
            $('.purchase-complete').remove();

        })

            .on('click', '.dismiss-purchase-journey', function () {
                setTimeout(function(){
                    location.reload(true);
                });
                // $('body').trigger('close-media-purchase-journey');
            });



        wp.element.render(
            wp.element.createElement( MediaPurchaseFunnel, {
                id:$(this).attr('data-rev-media-purchase-id'),
                type:$(this).attr('data-type')
            }),
            document.getElementById( 'rev-purchase-funnel' )
        );
    });

    Rev.$body.on("click", '.rev-service-updates-widget .closed-issues-toggle', function(e) {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('.rev-service-updates-widget .closed-issues').removeClass('open');
        } else {
            $(this).addClass('open');
            $('.rev-service-updates-widget .closed-issues').addClass('open');
        }
    });

    $('.filterable').each(function () {
        var $filterable = $(this);
        $('button[data-target]', $filterable).click(function () {
            if ($(this).hasClass('enabled')) { //if clicking on enabled button, remove all filters
                $('.filter-tabs button', $filterable).removeClass('enabled');
                $('.filterable-content .filterable-item', $filterable).removeClass('filtered-out');
            } else { //otherwise filter out
                var $slug = $(this).data('target');
                $('.filter-tabs button', $filterable).removeClass('enabled');
                $(this).addClass('enabled');

                $('.filterable-content .filterable-item', $filterable).addClass('filtered-out');
                $('.filterable-content .filterable-item'+$slug, $filterable).removeClass('filtered-out');
            }

            //Callback after each filter action
            if (typeof window[$filterable.data('callback')] === 'function') {
                window[$filterable.data('callback')]($filterable);
            }
        })
    });
    /*
        On scroll minify the menu
     */
    $(window).scroll(function () {
        if (Rev.$orderSummaryOffset) {
            // console.log("Order top: ", Rev.$orderSummaryOffset, "Scroll top + height:", $(window).scrollTop() + $(window).height() - Rev.$orderSummaryHeight);
            if ($(window).scrollTop() + $(window).height() - Rev.$orderSummaryHeight > Rev.$orderSummaryOffset) {
                Rev.$body.addClass('got-to-footer');
            } else {
                Rev.$body.removeClass('got-to-footer');
            }
        }


        if ($(window).scrollTop()) {
            Rev.$body.addClass('scrolled');
        } else {
            Rev.$body.removeClass(('scrolled'));
        }
    });


    /*
        Parallax for  masthead widgets
     */
    function mastheadWidgetParallax() {
        var scrollTop = $(window).scrollTop();
        var marginCover = 60;
        var headSpace = 100;
        var maxShadowOffset = 100;
        $('.rich-masthead-widget').each(function () {
            //Height of the content
            var $mediaContainer = $('.media-container', this);
            var $mediaWrapper = $('.media-wrapper', this);
            var initialHeight = $mediaContainer.innerHeight();
            var elementOffset =  $(this).offset().top;

            //Make sure the top container always stays at the original height (so scrollTop and scroll dependant animations are not affected)
            $(this).css('height', initialHeight + 'px');

            var difference = scrollTop + headSpace - elementOffset;

            // console.log('elementOffset',elementOffset,'scrollTop',scrollTop,'difference',difference,'sTop+Head',scrollTop + headSpace);
            if (scrollTop + headSpace > elementOffset) { //applying parallax
                // console.log('Parallax applied: scrollTop + headSpace',scrollTop + headSpace,'elementOffset',elementOffset);
                // console.log('difference',difference,'(initialHeight - (difference))',(initialHeight - (difference)))
                if (0 > (initialHeight - (difference))) { //If whole masthead is hidden, stop changing translations to avoid affecting other elements on site

                    $mediaContainer.css('transform', 'translateY(0)');
                } else {
                    //If part of of masthead should be hidden
                    $mediaContainer.css('transform', 'translateY(' + (difference) + 'px)'); //Move it
                    $mediaWrapper //crop it
                        .css('height', (initialHeight - (difference)) + 'px');
                }
                if (difference < marginCover) {
                    $(this)
                        .css('margin-bottom', difference + 'px')
                        .removeClass('with-parallax');
                } else {
                    $(this)
                        .css('margin-bottom', marginCover + 'px')
                        .addClass('with-parallax');
                }

            } else { //disable parallax
                // console.log('Parallax disabled: scrollTop + headSpace',scrollTop + headSpace,'elementOffset',elementOffset);
                $mediaContainer.css('transform', 'translateY(0)');
                $mediaWrapper.css('height', (initialHeight) + 'px'); //remove cropping
                $(this)
                    .css('margin-bottom', 0)
                    .removeClass('with-parallax');
            }
        });
    }
    $('.rich-masthead-widget').imagesLoaded().progress( function() {
        mastheadWidgetParallax(); //Retry initialization for mastheads with delayed images
    });
    $(window).scroll(mastheadWidgetParallax);



    /*
        Tilt for shadowed buttons
     */
    // $('.rev-button-widget').attr('data-tilt', true);
    $('.rev-button-widget').each(function (e) {
        $(this).tilt({
            glare: true,
            maxGlare: .75,
            perspective:1000,
            speed:550
        });
    });

    // /*
    //     Mark wp buttons that have images in content. They will animate a bit differently that ones with text only
    //  */
    // $('.wp-block-button__link img').parent().addClass('has-image');

    //Smooth scrolling with anchor links
    $('body').on('click', 'a[href^=\\#]', function(event){
        event.preventDefault();
        if ($(this.hash).offset() && ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].indexOf($(this.hash).prop("tagName").toUpperCase()) !== -1) {
            //Check content pull.
            var $offset = parseInt($('.page-container').css('margin-top').replace(/[^-\d\.]/g, ''));
            console.log($offset);
            $('html,body').animate({scrollTop:$(this.hash).offset().top -140}, 500);
        }
    });


    /*
        Parallax for masthead videos
     */
    // DF: Redo it. Add another container within and change it' height instead of parrent. Make parrent's height constant (inlin style). Changing height of parent while scrolling
    // DF: affects absolute offset of all elements below and confuses anchor link animations.
    function mastheadParallax() {
        var scrollTop = $(window).scrollTop();
        var headSpace = 0;
        $('.masthead-wrapper').each(function () {
            var $mediaContainer = $('.masthead-media', this);
            var $mediaWrapper = $('.media-wrapper', this);
            var initialHeight = $mediaContainer.innerHeight();
            var elementOffset =  $(this).offset().top;

            //Make sure the top container always stays at the original height (so scrollTop and scroll dependant animations are not affected)
            $(this).css('height', initialHeight + 'px');

            var difference = scrollTop - elementOffset;

            if (scrollTop + headSpace > elementOffset) { //applying parallax
                if (0 > (initialHeight - (difference))) { //If whole masthead is hidden, stop changing translations to avoid affecting other elements on site
                    $mediaContainer.css('transform', 'translateY(0)');
                } else {
                    $mediaContainer.css('transform', 'translateY(' + (difference) + 'px)'); //move it
                    $mediaWrapper.css('height', (initialHeight - (difference)) + 'px'); //crop it
                    $(this)
                        .addClass('with-parallax');
                }
                $('.page-container').addClass('with-parallax');
            } else { //disable parallax
                $mediaContainer.css('transform', 'translateY(0)');
                $mediaWrapper.css('height', (initialHeight) + 'px')
                $(this).removeClass('with-parallax');
                $('.page-container').removeClass('with-parallax');
            }
        });
    }
    $('.masthead-wrapper').imagesLoaded().progress( function(e, x, y, z) {
        mastheadParallax(); //Retry initialization for mastheads with delayed images
    });
    $(window).scroll(mastheadParallax);


    var revealElements = '.sreveal, ' +
        '.features .wp-block-column, ' +
        '.bundle-and-save .wp-block-column';
    var nonIntervalRevealElements =   '.rev-features-list-widget .feature';
    var fasterIntervalElements = '.fsreveal, ' +
        '.widget_categories .cat-item';

    ScrollReveal().reveal(revealElements, { interval: 200, distance: '40px', reset: true, delay: 0, viewFactor: 0.2, mobile: false });
    ScrollReveal().reveal(fasterIntervalElements, { interval: 16, distance: '40px', reset: true, delay: 0, viewFactor: 0.2 });
    ScrollReveal().reveal(nonIntervalRevealElements, { distance: '40px', reset: true, delay: 0, viewFactor: 0 });
    setTimeout(function () {
        ScrollReveal().sync();
        $('body').imagesLoaded().progress(function () {
            ScrollReveal().sync();
        });
    }, 2000);

    console.log('jQuery end: ', ((new Date).getTime() - Rev.stopWatch) / 1000);

    $('body').on('click', '#rev-purchase-funnel .continue-button button, #rev-purchase-funnel .go-back-button button', function (e) {
        console.log($(window).scrollTop());
        if ($(window).scrollTop() > $('.journey-breadcrumbs').offset().top) {
            $('html,body').animate({scrollTop:$('.journey-breadcrumbs').offset().top - 100}, 500);
        }
    });

    /*
        Site search
     */
    var searchFormContainer = document.getElementById( 'hinted-search-form' );
    if (searchFormContainer) {
        wp.element.render(
            <SiteSearch searchPhrase={Rev.searchQuery} />,
            searchFormContainer
        );
    }


    $('body')
        .on('focus', '.site-search .search-field', function () {
            $('.main-head').addClass('search-focused');
        })
        .on('blur', '.site-search .search-field', function () {
            $('.main-head').removeClass('search-focused');
        })
        .on('mouseover', '.site-search', function () {
            $('.main-head').addClass('search-hovered');
        })
        .on('mouseleave', '.site-search', function () {
            $('.main-head').removeClass('search-hovered');
        })
    ;

    /*
        Datatables
     */
    if ($('table.channel_lineup').length > 0) {
        // Initiate Datatables
        var $channel_lineup_table = $('table.channel_lineup').DataTable({
            responsive: true,
            fixedHeader: true,
            "pageLength": 100,
            "bInfo": false,
            "aoColumnDefs": [
                { "sClass": "even-column", "aTargets": [ 4, 6, 8 ] }
            ]

        });

        // Scroll to top on pagination
        // $('body').on('click', '.paginate_button', function () {
        //     setTimeout(function () {
        //         $('html, body').animate({scrollTop: $("h1").offset().top}, 250);
        //     }, 250);
        // });
    }

    /*
        Responsive button images
     */
    $('.wp-block-button__link img').each(function () {
        $(this).data('originalHeight', $(this).css('height')).addClass('marked');
    });

    /*
        Responsive spacer
     */
    $('.wp-block-spacer').each(function () {
        $(this).data('originalHeight', $(this).css('height'));
    });
    $(window).resize(function (e) {
        var $width = $(window).width();
        $('.wp-block-spacer, .wp-block-button__link img').each(function () {
            var originalHeight = parseInt($(this).data('originalHeight').replace('px', ''));
            var newHeight = originalHeight;
            if ($width < 1380) {
                newHeight = originalHeight * 0.9;
            }
            if ($width < 1220) {
                newHeight = originalHeight * 0.7;
            }
            if ($width < 1000) {
                newHeight = originalHeight * 0.6;
            }
            if ($width < 768) {
                newHeight = originalHeight * ($width / 1340);
            }
            $(this).css('height', newHeight + 'px');
        });
    });

    /*
        Highlights slider on mobile
     */
    $('.rev-accordion-slider-widget ul li').hover(
        function () {
            if ($(window).width() < 1000) {
                console.log("Slide down");
                $('.description', $(this)).slideDown()
            } else {

            }
        },
        function () {
            if ($(window).width() < 1000) {
                console.log("Slide up");
                $('.description', $(this)).slideUp()
            } else {

            }
        }
    );

    /*
        Responsive Bundles list
     */
    if ($('.sm-swipable').length) {
        $(window).resize(function () {
            if ($(window).width() < 1000) {
                if (Rev.swipable) return; //If loaded then bail
                $('.sm-swipable').addClass('swiper-container');
                $('.sm-swipable > .row, .sm-swipable > .swipable-wrapper').addClass('swiper-wrapper');
                $('.sm-swipable > .row > div, .sm-swipable > .swipable-wrapper > div').addClass('swiper-slide');

                var slides = 3;
                var centerSlides = false;
                if ($(window).width() <= 768) {
                    slides = 'auto';
                    centerSlides = true;
                }

                Rev.swipable = new Swiper ('.sm-swipable', {
                    initialSlide:0,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',

                    },
                    pagination: {
                        el: '.swiper-pagination',
                    },

                    slidesPerView: slides,
                    centeredSlides: centerSlides,
                    spaceBetween: 0,
                });
                $('.sm-swipable').each(function () { //mark swipers with pagination
                    if ($('.swiper-pagination-bullet', this).length) {
                        $(this).addClass('has-pagination');
                    }
                });
            } else {
                if (Rev.swipable) {
                    $('.sm-swipable').removeClass('swiper-container');
                    $('.sm-swipable > .row, .sm-swipable > .swipable-wrapper').removeClass('swiper-wrapper');
                    $('.sm-swipable > .row > div, .sm-swipable > .swipable-wrapper > div').removeClass('swiper-slide');

                    Rev.swipable.destroy();
                    Rev.swipable = null;
                }
            }
        });
    }

    /*
        Responsive addons widget
     */
    if ($('.addons-widget').length) {
        $('.addon-groups-nav .nav-item').on('shown.bs.tab', function () {
            console.log('Tab shown');
            $(window).trigger('resize'); //Toggle resize so it adds swiper if needed
        });

        $(window).resize(function () {
            if ($(window).width() < 1000) {
                if ($('.addons-widget .tab-pane.active').data('swiper')) return; //If loaded then bail

                //prep classes
                $('.addons-widget .addons-in-group').addClass('swiper-container');
                $('.addons-widget .addons-in-group > .row').addClass('swiper-wrapper');
                $('.addons-widget .addons-in-group .addon').addClass('swiper-slide');


                var slides = 3;
                var centerSlides = false;
                if ($(window).width() <= 768) {
                    slides = 'auto';
                    centerSlides = true;
                }
                //Add swiper to addons in active group
                $('.addons-widget .tab-pane.active').data('swiper', new Swiper ('.addons-widget .tab-pane.active .swiper-container', {
                    initialSlide:0,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    slidesPerView: slides,
                    centeredSlides: centerSlides,
                    spaceBetween: 0,
                }));
                $('.addons-widget .tab-pane.active .swiper-container').each(function () { //mark swipers with pagination
                    if ($('.swiper-pagination-bullet', this).length) {
                        $(this).addClass('has-pagination');
                    }
                });
            } else {
                //On larger screen wipe all swipers
                $('.addons-widget .tab-pane').each(function () {
                    $('.addons-widget .tab-content').removeClass('swiper-container');
                    $('.addons-widget .addons-wrapper').removeClass('swiper-wrapper');
                    $('.addons-widget .tab-pane').removeClass('swiper-slide');

                    if ($(this).data('swiper')) {
                        $(this).data('swiper').destroy();
                        $(this).data('swiper', null);
                    }
                })
            }
        });
    }

    /*
        Mobile nav
     */
    $('.menu-toggle.mobile-only').click(function () {
        $('body').toggleClass('mobile-menu-open');
        if ($(this).hasClass('magnifier')) {
            setTimeout(function () {
                $('.mobile-nav .site-search-mobile .search-field').focus();
            }, 300);
        }
    });

    $('#menu-footer-menu > li > a').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('.sub-menu', $(this).parent()).slideToggle();
    });

    /*
        Responsive mobile font
     */
    $(window).resize(function () {
        if ($(window).width() <= 768) {
            var newSize = Math.max($(window).width() * 75 / 768, 33.333333);
            $('html').css('font-size', (newSize) + '%' );
        } else {
            $('html').css('font-size', '' );
        }
    });

    /*
        Show live chat button after chat window is loaded
     */
    // Rev.VelaroChatLoaderTimer = setInterval(function () { //check every second if chat loaded
    //     if ($('#velarochat-container-dynamic, #velaro-mobile-inline').length) {
    //         //Load event handler
    //         $('body').on('click', '.rev-live-chat-button, a[href="#live-chat"]', function () {
    //             if ($('#chatwindow-01').length) {
    //                 $('#chatwindow-01').trigger('click');
    //             } else if ($('#velaro-mobile-inline').length) {
    //                 $('#velaro-mobile-inline').trigger('click');
    //             }
    //
    //         });
    //         $('.rev-live-chat-button').fadeIn();
    //         clearInterval(Rev.VelaroChatLoaderTimer );
    //     }
    // },1000);
    //
    //
    // /*
    //     Live chat
    //  */
    // (function(){
    //     var globals = document.createElement('script');
    //     globals.src = 'https://galleryuseastprod.blob.core.windows.net/velaroscripts/2118/globals.js';
    //
    //     var inline = document.createElement('script');
    //     inline.src = 'https://eastprodcdn.azureedge.net/bundles/velaro.inline.js';
    //
    //     var scriptNode = document.getElementsByTagName('script')[0];
    //     scriptNode.parentNode.insertBefore(globals, scriptNode);
    //
    //     globals.onload = function () {
    //         Velaro.Globals.ActiveSite = 2118;
    //         Velaro.Globals.ActiveGroup = 0;
    //         Velaro.Globals.InlineEnabled = true;
    //         Velaro.Globals.VisitorMonitoringEnabled = true;
    //         Velaro.Globals.InlinePosition = 0;
    //         scriptNode.parentNode.insertBefore(inline, scriptNode)
    //     }
    // }());

    /*
        Styled YouTube frames (also, regular iframes can't be swiped on mobile, we need cover them with parent frame DOM items)
     */
    //Load script
    function loadYTScript() {
        var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // 3. This function creates an <iframe> (and YouTube player)
        //    after the API code downloads.
        window.onYouTubeIframeAPIReady = function () {
            //For each iframe with youtube
            $('.video-wrapper iframe').each(function () {
                //create YT.Player object and attach to wrapper
                var $iframe = $(this);
                var $wrapper = $(this).closest('.video-wrapper');

                //When player loaded attach title, and event handlers
                var $id = $(this).attr('id');
                var player;
                player = new YT.Player($id, {
                    events: {
                        'onReady': function () {
                            console.log('Ready:', (player.getVideoData().title));
                            console.log('Player title DOM', $('.cover .title', $wrapper));
                            $('.title', $wrapper).html(player.getVideoData().title).removeClass('hidden');
                            $('.cover, .title', $wrapper).click(function (e) {
                                $('.cover', $wrapper).fadeOut();
                                $('.compact.title', $wrapper).fadeOut();
                                $('iframe', $wrapper).fadeIn(function () {
                                    console.log('Play video');
                                    player.playVideo();
                                });
                            });

                        },
                        // 'onStateChange': onPlayerStateChange
                    }
                });
                $wrapper.data('yt-player', player);

            });

        }
    }
    loadYTScript();

    /*
        External links class
     */
    $('.external a, a.external').attr('target', '_blank'); //
    var x;

    /*
        iframe autoheight
     */
    window.addEventListener("message", function(event) {
        console.log(event);
        if ((event.origin === Rev.origin || event.origin === "https://api.cablebahamas.com") && event.data.windowHeight) {
            $('.purchase-funnel .payment iframe').css('height', event.data.windowHeight + 'px');
            $('.purchase-funnel .payment').css('min-height', (event.data.windowHeight + 40) + 'px');
        }
    }, false);

    /*
        Main menu subnav reveal
     */
    $('#menu-mega-menu .menu-item').hover(
        function () {
            var $self = $(this);
            $('.sub-menu', $self).css('display', 'block');
            setTimeout(function () {
                $self.addClass('hover');
            });
            if (Rev.mainNavSubMouseoutTimer) {
                clearTimeout(Rev.mainNavSubMouseoutTimer);
                Rev.mainNavSubMouseoutTimer = null;
            }
        },
        function () {
            var $self = $(this);
            $self.removeClass('hover');
            if (Rev.mainNavSubMouseoutTimer) {
                clearTimeout(Rev.mainNavSubMouseoutTimer);
                Rev.mainNavSubMouseoutTimer = null;
            }

            Rev.mainNavSubMouseoutTimer = setTimeout(function () {
                Rev.mainNavSubMouseoutTimer = null;
                $('.sub-menu', $self).css('display', 'none');
            }, 300);
        }
    );


    $(window).trigger('scroll');
    $(window).trigger('resize');

    //DF: Periodically check if there is a new / updated cart data available throughout purchase journey and inform user about the cart update. Alternatively block purchase journey on secondary tabs.
});